import { useEffect, useState } from "react";
import { useApiClient } from "../../../../data/clients/ApiClient";
import { PageQuery } from "../../../../utils/models/pageQuery";

const CHAIN_LOGO_CLASSIFICATION = "11";
const HAS_CHAIN_LOGOS_KEY = "hasChainLogos";

export function useHasChainLogos(role?: number, isVendor?: boolean): boolean {
  const [hasChainLogos, setHasChainLogos] = useState<boolean>(false);
  const apiClient = useApiClient();

  // If admin role, always return true immediately, bypass all logic
  if (role === 2) {
    return true;
  }

  useEffect(() => {
    // Only run check for Vendor roles
    if (!isVendor) {
      setHasChainLogos(false);
      return;
    }

    // Check localStorage first
    const cachedValue = localStorage.getItem(HAS_CHAIN_LOGOS_KEY);

    if (cachedValue !== null) {
      setHasChainLogos(cachedValue === "true");

      if (cachedValue === "true") return;
    }

    // Let's only fetch if null (never checked) to avoid repeated calls if they really don't have any.
    if (cachedValue === null) {
      const checkChainLogos = async () => {
        try {
          const query: PageQuery = {
            page: { size: 1, index: 1 },
            filterBy: [
              { field: "classification", value: CHAIN_LOGO_CLASSIFICATION },
            ],
            searchTerm: "",
            sortBy: { field: "", sortDirection: undefined },
          };

          // Direct API call is simpler for a one-off useEffect side-effect.
          const response = await apiClient.getAllLogos(query);

          const hasLogos = response.results.length > 0;
          setHasChainLogos(hasLogos);
          localStorage.setItem(HAS_CHAIN_LOGOS_KEY, String(hasLogos));
        } catch (error) {
          console.error("Failed to check for chain logos", error);
          // Default to false on error, don't save to storage so we retry next time
          setHasChainLogos(false);
        }
      };

      checkChainLogos();
    }
  }, [isVendor, apiClient]);

  return hasChainLogos;
}
